export const HERO_IMG = "https://d2xsxph8kpxj0f.cloudfront.net/310519663140801251/BEx4AVNzGNFDZYtpPkANAf/hero-data-governance-N9YJK87TUyhUcv7CEeBRXK.webp";

export const NAVY = '#1B365D';
